import { gql } from "apollo-angular";

export const  DIF = gql`
  fragment DIF on DisclaimerItem {
    title
    disclaimer
  }`;
